import { ApiService } from "@/api";

export default {
  GET_SERVER({ commit }, id) {
    return ApiService.servers.get(id).then((server) => {
      commit("SET_SERVER", server);
      return server;
    });
  },
  GET_RECOMMENDED_DVR_SERVERS({ commit }, id_server) {
    return ApiService.servers.getRecommend(id_server).then((servers) => {
      commit("SET_RECOMMEND_DVR_SERVERS", servers);
    });
  },
  GET_RECOMMENDED_RESERVE_SERVERS({ commit }, { id, clusterAlias }) {
    return ApiService.servers.getRecommendReserve(id, clusterAlias).then((servers) => {
      commit("SET_RECOMMEND_RESERVE_SERVERS", servers);
    });
  },
  DELETE_SERVER(context, id) {
    return ApiService.servers.delete(id);
  },
  UPDATE_SERVER(context, { id, newServer }) {
    return ApiService.servers.update(id, newServer);
  },
  UPDATE_SERVER_IS_NEW_AGENT(context, { id, isNewAgent }) {
    return ApiService.servers.updateIsNewAgent(id, isNewAgent);
  },
  GET_MODES({ commit }) {
    return ApiService.servers.getModes().then((modes) => {
      commit("SET_MODES", modes);
    });
  },
  GET_SERVER_GROUPS() {
    return ApiService.servers.getServerGroups().then((res) => {
      return res;
    });
  },
  GET_SERVER_RESERVE_TRANSFERS({ commit }, { id, headers = {page: 1, count: 10} }) {
    return ApiService.servers.getServerReserveTransfersList(id, headers)
      .then((reserveTransfers) => {
        commit("SET_RESERVE_TRANSFERS", reserveTransfers);
      });
  },
  RETURN_CAMERAS({ commit }, { id, force }) {
    return ApiService.servers.returnCameras(id, force)
      .then((res) => {
        return res.data;
      });
  },
};
